import { render } from "./UsersSubMenu.vue?vue&type=template&id=498a2411"
import script from "./UsersSubMenu.vue?vue&type=script&lang=js"
export * from "./UsersSubMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__